import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Params = uui.domain.actions.rpc.simulation.UpdateSimulationAction['params']

/**
 * Update a Simulation details.
 *
 * @private
 */
export const updateSimulation = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/simulation/update', async (params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/simulation/update', {
      category: 'rpc',
      type: 'rpc/simulation/update',
      params,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      'Unknown error on {updateSimulation}',
      { tags: ['rpc', 'simulation'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Updating Simulation Failed',
      error,
    })
  }
})
